import Link from 'next/link';
import { useState } from 'react';

import { useResize } from '@scripts/hooks/useResize';

import { BrandListProps } from '../types';
import styles from './BrandList.module.scss';

const BrandList = ({ brands }: BrandListProps) => {
    const { isScreenMd } = useResize();
    const NUM_VISIBLE = isScreenMd ? 23 : 5;
    const collator = new Intl.Collator();

    const [expanded, setExpanded] = useState<Record<string, boolean>>({});

    const toggle = (letter: string) => {
        setExpanded(prev => ({
            ...prev,
            [letter]: !prev[letter],
        }));
    };

    return (
        <div className={styles.root}>
            {Object.entries(brands)
                .sort(([a], [b]) => collator.compare(a, b))
                .map(([letter, items]) => {
                    const isExpanded = expanded[letter];
                    const visibleItems = isExpanded ? items : items.slice(0, NUM_VISIBLE);

                    return (
                        <div key={letter.toUpperCase()} className={styles.group}>
                            <div className={styles.letterHeader} id={letter.toUpperCase()}>
                                <h2 className={styles.letter}>{letter.toUpperCase()}</h2>
                            </div>
                            <div className={styles.list}>
                                {visibleItems.map(el => (
                                    <div key={el.id}>
                                        <Link
                                            legacyBehavior
                                            href={`/brands/${el?.code}-${el.id}`}
                                            passHref
                                            prefetch={false}
                                        >
                                            <a aria-label={el.name} className={styles.link}>
                                                {el.name}
                                            </a>
                                        </Link>
                                    </div>
                                ))}
                                {items.length > NUM_VISIBLE && (
                                    <button
                                        type="button"
                                        data-testid="button-all-brands"
                                        onClick={() => toggle(letter)}
                                        className={styles.toggle}
                                    >
                                        {isExpanded ? 'Скрыть' : 'Показать все'}
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default BrandList;
